import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';

const css = oxygenCss({
  root: {
    display: 'inline-block',
    fill: 'currentColor',
    verticalAlign: 'middle'
  }
});

class EmailGift extends Component {
  static propTypes = {
    className: PropTypes.string
  };

  render() {
    const { className, ...other } = this.props;
    return (
      <svg
        {...other}
        xmlns="http://www.w3.org/2000/svg"
        width="352"
        height="352"
        viewBox="0 0 352 352"
        version="1.1"
        className={classNames(css.root, className)}
        stroke="none"
        strokeWidth="1"
        fillRule="evenodd"
      >
        <g stroke="none" strokeWidth="1" fill="none" fill-rule="evenodd">
          <circle fill="#FFFFFF" cx="176" cy="176" r="176" />
          <g transform="translate(100.336449, 100.336449)">
            <path
              d="M138.740274,111.850467 C135.28972,107.738318 124.872263,102.803738 124.872263,102.803738 L118.292824,107.327103 L118.978204,116.373832 L136.11215,116.785047 L138.740274,111.850467 Z"
              fill="#EAD8C5"
            />
            <path
              d="M108.560748,0 C94.2102011,0 86.1926938,11.6778467 82.2429907,20.1754228 C78.2932875,11.6778467 70.2757802,0 55.9252336,0 C46.856003,0 39.4766355,7.37936748 39.4766355,16.4485981 C39.4766355,25.5178288 46.856003,32.8971963 55.9252336,32.8971963 L82.2429907,32.8971963 L108.560748,32.8971963 C117.629978,32.8971963 125.009346,25.5178288 125.009346,16.4485981 C125.009346,7.37936748 117.629978,0 108.560748,0 Z M55.9252336,26.317757 C50.4830505,26.317757 46.0560748,21.8907813 46.0560748,16.4485981 C46.0560748,11.006415 50.4830505,6.57943925 55.9252336,6.57943925 C68.441597,6.57943925 75.0660067,19.5054056 77.6874856,26.317757 L55.9252336,26.317757 Z M108.560748,26.317757 L86.7984957,26.317757 C89.4199746,19.5054056 96.0443843,6.57943925 108.560748,6.57943925 C114.002931,6.57943925 118.429907,11.006415 118.429907,16.4485981 C118.429907,21.8907813 114.002931,26.317757 108.560748,26.317757 Z"
              fill="#4CDEE0"
            />
            <path
              d="M131.588785,111.850467 L29.6074766,111.850467 C27.7905974,111.850467 26.317757,110.377594 26.317757,108.560748 L26.317757,49.3457944 C26.317757,47.5289151 27.7905974,46.0560748 29.6074766,46.0560748 L134.878505,46.0560748 C136.695351,46.0560748 138.168224,47.5289151 138.168224,49.3457944 L138.168224,105.271028 C138.168224,108.904754 135.222511,111.850467 131.588785,111.850467 Z"
              fill="#DEDEDE"
            />
            <path
              d="M144.747664,52.635514 L19.7383178,52.635514 C16.1045921,52.635514 13.1588785,49.6898004 13.1588785,46.0560748 L13.1588785,32.8971963 C13.1588785,29.2634707 16.1045921,26.317757 19.7383178,26.317757 L144.747664,26.317757 C148.381389,26.317757 151.327103,29.2634707 151.327103,32.8971963 L151.327103,46.0560748 C151.327103,49.6898004 148.381389,52.635514 144.747664,52.635514 Z"
              fill="#FBFBFB"
            />
            <rect
              fill="#4CDFE0"
              x="65.7943925"
              y="26.317757"
              width="32.8971963"
              height="26.317757"
            />
            <rect
              fill="#45CFD0"
              x="65.7943925"
              y="52.635514"
              width="32.8971963"
              height="59.2149533"
            />
            <path
              d="M138.740274,111.850467 L52.635514,111.850467 C49.0017884,111.850467 46.0560748,108.904754 46.0560748,105.271028 L46.0560748,105.271028 C46.0560748,101.637302 49.0017884,98.6915888 52.635514,98.6915888 L81.6850213,98.6915888 C87.0285129,98.6915888 91.8180815,94.6905989 92.0981353,89.3544434 C92.3968419,83.662735 87.8711417,78.953271 82.2429907,78.953271 L0,78.953271 L0,126.585121 L54.1133219,149.144111 C60.1032434,151.389542 66.7302849,151.357993 72.8268262,149.818766 L145.505845,123.762838 C143.976422,118.662029 141.64128,114.757296 138.740274,111.850467 Z"
              fill="#ECCDAB"
            />
          </g>
        </g>
      </svg>
    );
  }
}

export default EmailGift;



// WEBPACK FOOTER //
// ./src/js/Cio/Assets/EmailGift.js